import { Component } from 'react';
import PropTypes from 'prop-types';
import notify from '@fountain/ui-kit/components/notifications';

export default class ErrorsCatcher extends Component {
  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: null,
  }

  componentDidCatch() {
    notify('An error occurred', 'error');
  }

  render() {
    return this.props.children;
  }
}
